import { EmailMessageType, SurveyType } from '../services/api/sharedTypes/Email'
import { EmailAutomationSettingsDto } from '../services/api/sharedTypes/EmailAutomationSettings'

export enum EmailTab {
    Waiting = 'waiting',
    Templates = 'templates',
    FilledSurveys = 'filledSurveys',
    Settings = 'settings',
}

export const getEmailTab = (tab: string) => {
    if (tab === EmailTab.Waiting) return EmailTab.Waiting
    if (tab === EmailTab.Templates) return EmailTab.Templates
    if (tab === EmailTab.FilledSurveys) return EmailTab.FilledSurveys
    if (tab === EmailTab.Settings) return EmailTab.Settings
    return EmailTab.Waiting
}

export const getEmailTabNumber = (tab: EmailTab) => {
    if (tab === EmailTab.Waiting) return 0
    if (tab === EmailTab.Templates) return 1
    if (tab === EmailTab.FilledSurveys) return 2
    if (tab === EmailTab.Settings) return 3
    return 0
}

export const convertNumberToEmailTab = (data: number) => {
    if (data === 0) return EmailTab.Waiting
    if (data === 1) return EmailTab.Templates
    if (data === 2) return EmailTab.FilledSurveys
    if (data === 3) return EmailTab.Settings
    return EmailTab.Waiting
}

export const convertSurveyTypeToString = (type: SurveyType) => {
    if (type === SurveyType.ClientFeedback) return 'Dotazník spokojenosti po akci'
    if (type === SurveyType.EventRejectedFeedback) return 'Proč to nevyšlo?'
    return 'Bez názvu'
}

export const convertStringToEmailMessageType = (data: string): EmailMessageType => {
    if (data === 'NotSet') return EmailMessageType.NotSet
    if (data === 'InvoiceCreated') return EmailMessageType.InvoiceCreated
    if (data === 'EventFinished') return EmailMessageType.EventFinished
    if (data === 'EventRejected') return EmailMessageType.EventRejected
    if (data === 'RemindPendingOffer') return EmailMessageType.RemindPendingOffer
    if (data === 'RemindApproachingEventStart') return EmailMessageType.RemindApproachingEventStart
    if (data === 'RemindNotPaidEvent_Severity1') return EmailMessageType.RemindNotPaidEvent_Severity1
    if (data === 'RemindNotPaidEvent_Severity2') return EmailMessageType.RemindNotPaidEvent_Severity2
    if (data === 'RemindEventRepetition') return EmailMessageType.RemindEventRepetition
    return EmailMessageType.NotSet
}

export const convertEmailMessageTypeToString = (type: EmailMessageType) => {
    if (type === EmailMessageType.NotSet) return 'Nenastaveno'
    if (type === EmailMessageType.InvoiceCreated) return 'Faktura vytvořena'
    if (type === EmailMessageType.EventFinished) return 'Akce dokončena'
    if (type === EmailMessageType.EventRejected) return 'Akce zamítnuta'
    if (type === EmailMessageType.RemindPendingOffer) return 'Připomenout nevyřízenou nabídku'
    if (type === EmailMessageType.RemindApproachingEventStart) return 'Připomenout blížící se akci'
    if (type === EmailMessageType.RemindNotPaidEvent_Severity1) return 'Připomenout nezaplacenou akci - 1. varování'
    if (type === EmailMessageType.RemindNotPaidEvent_Severity2) return 'Připomenout nezaplacenou akci - 2. varování'
    if (type === EmailMessageType.RemindEventRepetition) return 'Připomenout opakování akce'
    return 'Nenastaveno'
}

export const convertEmailAutomationSettingsToString = (data: keyof EmailAutomationSettingsDto) => {
    if (data === 'remindPendingOfferTimeout') return 'Připomenout nevyřízenou nabídku'
    if (data === 'remindApproachingEventStartTimeout') return 'Připomenout blížící se akci'
    if (data === 'remindNotPaidEventTimeout_Severity1') return 'Připomenout nezaplacenou akci - 1. varování'
    if (data === 'remindNotPaidEventTimeout_Severity2') return 'Připomenout nezaplacenou akci - 2. varování'
    if (data === 'remindEventRepetitionTimeoutMonths') return 'Připomenout opakování akce (po měsících)'
    return
}

export const getEmailExplanationFromEmailMessageType = (type: EmailMessageType) => {
    if (type === EmailMessageType.NotSet) return 'Nenastaveno'
    if (type === EmailMessageType.InvoiceCreated) return 'Faktura vytvořena - po vytvoření faktury'
    if (type === EmailMessageType.EventFinished) return 'Akce dokončena - akce je zaplacena a dokončena'
    if (type === EmailMessageType.EventRejected) return 'Akce zamítnuta - akce je neakceptována'
    if (type === EmailMessageType.RemindPendingOffer) return 'Připomenout nevyřízenou nabídku'
    if (type === EmailMessageType.RemindApproachingEventStart) return 'Připomenout blížící se akci'
    if (type === EmailMessageType.RemindNotPaidEvent_Severity1) return 'Připomenout nezaplacenou akci - 1. varování'
    if (type === EmailMessageType.RemindNotPaidEvent_Severity2) return 'Připomenout nezaplacenou akci - 2. varování'
    if (type === EmailMessageType.RemindEventRepetition) return 'Připomenout opakování akce'
    return 'Nenastaveno'
}
